// extracted by mini-css-extract-plugin
export var createdDate = "_id-1";
export var divider = "_id-2";
export var headerDivider = "_id-3";
export var messagesCard = "_id-0";
export var messagesContainer = "_id-7";
export var messagesContainerWrapper = "_id-4";
export var pointerCapturingButtonBoxes = "_id-a";
export var showLeftPanelButton = "_id-9";
export var showMoreButton = "_id-c";
export var showMoreButtonContainer = "_id-b";
export var summaryTitle = "_id-6";
export var systemMessageCardWrapper = "_id-d";
export var topButtons = "_id-8";
export var withPadding = "_id-5";